export default "__VITE_ASSET__B$V26yYf__"